export default "__VITE_ASSET__CRauesS4__"